import {useEffect} from "react";
import styles from './Guidelines.module.css';

const Guidelines = () => {
	useEffect(() => {
        document.title = 'Guidelines';
    }, []);

	return (
		<div className={styles.container}>
			<div className={styles.subheader}>
				Our Community Guidelines
			</div>
			<div className={styles.paragraph}>
				We seek to build a community that is safe and welcoming to everyone, no matter their
				race, ethnicity, national origin, caste, sexual orientation, gender, gender identity,
				religious affiliation, age, disability, or health status. Violence, threats, hate, racism, and
				harassment will not be tolerated.
			</div>
			<div className={styles.paragraph}>
				We strive towards accuracy and transparency in all our work. As a data-driven
				organization, we do not support or perpetuate the spreading of false information.
			</div>
			<div className={styles.paragraph}>
				We treat our community members with respect, kindness, and consideration, and we
				expect our community members to show the same respect for our staff.
			</div>
			<div className={styles.paragraph}>
				We value honesty and authenticity, including when it comes to representing who you are
				on our site. We believe that identity plays an important role in philanthropy and thus
				discourage using a fake identity. We respect anonymous giving, which is different from
				providing misleading information.
			</div>
		</div>
	)
};

export default Guidelines;